export default __webpack_public_path__ + "static/StickARound-b8a261ce4d06ee0141309c67be3f37ac.woff2";